import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchPaivat, fetchKattaukset } from "../supabaseClient";

export default function Confirmation() {
  const location = useLocation();
  const navigate = useNavigate();

  // Try to get reservation from location state first, then from query params as fallback
  const reservationFromState = location?.state?.reservation ?? null;

  const search = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
  const reservationFromQuery =
    search && search.get("id")
      ? {
          id: search.get("id"),
          paiva: search.get("paiva") ?? null,
          kattaus: search.get("kattaus") ?? null,
          ihmiset: search.get("ihmiset") ?? null,
          varaaja: search.get("varaaja") ?? null,
          puhelin: search.get("puhelin") ?? null,
          sposti: search.get("sposti") ?? null,
          info: search.get("info") ?? null,
          created_at: search.get("created_at") ?? null,
        }
      : null;

  const res = reservationFromState || reservationFromQuery;

  // resolved labels for display (paiva -> paivat.paiva, kattaus -> kattaukset.aika)
  const [paivaLabel, setPaivaLabel] = useState(null);
  const [kattausLabel, setKattausLabel] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function resolveLabels() {
      if (!res) return;

      // Helper to decide if a value looks like an id (numeric)
      const looksLikeId = (v) => {
        if (v === null || v === undefined) return false;
        // treat purely numeric strings or numbers as ids
        return String(v).trim() !== "" && !Number.isNaN(Number(String(v)));
      };

      // Resolve paiva
      if (looksLikeId(res.paiva)) {
        try {
          const paivat = await fetchPaivat();
          if (!mounted) return;
          const found = (paivat || []).find((p) => String(p.id) === String(res.paiva));
          setPaivaLabel(found ? found.paiva : String(res.paiva));
        } catch {
          if (mounted) setPaivaLabel(String(res.paiva));
        }
      } else {
        setPaivaLabel(res.paiva ?? "");
      }

      // Resolve kattaus
      if (looksLikeId(res.kattaus)) {
        try {
          // fetchKattaukset can be used; we fetch all and match by id
          const kattaukset = await fetchKattaukset();
          if (!mounted) return;
          const foundK = (kattaukset || []).find((k) => String(k.id) === String(res.kattaus));
          setKattausLabel(foundK ? foundK.aika : String(res.kattaus));
        } catch {
          if (mounted) setKattausLabel(String(res.kattaus));
        }
      } else {
        setKattausLabel(res.kattaus ?? "");
      }
    }

    resolveLabels();
    return () => {
      mounted = false;
    };
  }, [res]);

  function handleBack() {
    navigate("/", { replace: true });
  }

  function handleCopy() {
    if (!res) return;
    const text = `Reservation ${res.id ?? ""}\nDate: ${paivaLabel ?? res.paiva ?? ""}\nSitting: ${kattausLabel ?? res.kattaus ?? ""}\nPeople: ${res.ihmiset ?? ""}\nName: ${res.varaaja ?? ""}\nPhone: ${res.puhelin ?? ""}\nEmail: ${res.sposti ?? ""}\nLisätieto: ${res.info ?? ""}`;
    navigator.clipboard?.writeText(text).catch(() => {});
  }

  if (!res) {
    return (
      <div style={{ padding: 20, textAlign: "center", fontFamily: '"Comic Sans MS", "Comic Sans", cursive' }}>
        <h1>Reservation</h1>
        <p>No reservation data found. If you were just redirected here, ensure the booking page passes the created reservation via location state.</p>
        <button onClick={handleBack} style={{ padding: "8px 12px", marginTop: 12 }}>
          Back to booking
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: 20,
        textAlign: "center",
        fontFamily: '"Comic Sans MS", "Comic Sans", cursive',
        maxWidth: "100vw",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <h1>Varaus vahvistettu</h1>
      <p>Kiitos — varauksesi on vahvistettu. Vahvistus on lähetetty sähköpostiisi.</p>
      <p style={{ color: "black" }}>Tarkistathan myös roskapostikansiosi.</p>
      <div
        style={{
          marginTop: 12,
          padding: 12,
          border: "1px solid #ddd",
          maxWidth: "min(560px, 100%)",
          width: "100%",
          boxSizing: "border-box",
          textAlign: "left",
          overflowWrap: "break-word",
          wordWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        <div>
          <strong>Päivä:</strong> {paivaLabel ?? res.paiva ?? "—"}
        </div>
        <div>
          <strong>Aika:</strong> {kattausLabel ?? res.kattaus ?? "—"}
        </div>
        <div>
          <strong>Henkilömäärä:</strong> {res.ihmiset ?? "—"}
        </div>
        <div>
          <strong>Nimi:</strong> {res.varaaja ?? "—"}
        </div>
        <div>
          <strong>Puhelin:</strong> {res.puhelin ?? "—"}
        </div>
        <div>
          <strong>Sähköposti:</strong> {res.sposti ?? "—"}
        </div>
        <div style={{ marginTop: 8 }}>
          <strong>Lisätieto:</strong> {res.info ? res.info : "—"}
        </div>
      </div>

      <div style={{ marginTop: 12, display: "flex", gap: 8, justifyContent: "center" }}>
        <button onClick={handleBack}>
          Etusivulle
        </button>
      </div>
    </div>
  );
}
